<template>
    <v-container grid-list-xl fluid>
      <!-- <FabricRangeSelector type="Roller Blind" :value="selectedFabricGroup" v-on:selected-fabric-group="selectedFabricGroup = $event" :v="$v.selectedFabricGroup" :error="$v.selectedFabricGroup.$error"></FabricRangeSelector> -->

      <!-- <DimensionSelector v-on:room="setRoom($event)" :valueName="item.name" :valueWidth="item.width" :valueDrop="item.drop" ref="dimensionSelector" @ready="isReady => readyToSubmitDimension = isReady" :type="this.item.type"></DimensionSelector> -->
      <div v-if="$v.item.$error && !$v.item.name.required" class="red--text">Please enter Name</div>
      <v-text-field label="Name" v-model="item.name" :v="$v.item.name"></v-text-field>
      <CustomizationSelector title="Option" :value="item.variations.scaffolding" :options="['Scaffolding']" v-on:selected-option="item.variations.scaffolding = $event" :v="$v.item.variations.scaffolding" :error="$v.item.variations.scaffolding.$error"></CustomizationSelector>

      <!-- <v-textarea name="notes" label="Item Notes" v-model="item.notes"></v-textarea> -->
      <v-btn v-if="!edit" @click="addItem()" color="primary">Add {{ item.type }}</v-btn>
      <v-btn v-else @click="addItem()" color="primary">Update {{ item.type }}</v-btn>
      <b>${{ (item.total).toFixed(2) }}</b>
    </v-container>
</template>

<script>
import ItemService from '@/services/ItemService.js'
import CustomizationSelector from '@/components/parts/CustomizationSelector'
import { required } from 'vuelidate/lib/validators'

// const gConfig = require('../../../gConfig.json')

export default {
  props: {
    edittingItem: {
      default: null
    },
    editChange: {
      default: null
    }
  },
  components: {
    CustomizationSelector
  },
  data () {
    return {
      pelmetSizeOptions: [],
      pelmetColorOptions: [],
      pelmetFinishOptions: [],
      item: {
        type: 'Scaffold',
        color: null,
        orderID: null,
        name: null,
        width: null,
        itemPrice: 0,
        total: 0,
        notes: null,
        quantity: 1,
        variations: {
          scaffolding: null
        },
        ordering: 1000
      },
      edit: false
    }
  },
  validations: {
    item: {
      name: { required },
      // width: { required },
      // drop: {required},
      // color: { required },
      variations: {
        scaffolding: { required }
      }
    }
  },
  watch: {
    edittingItem (item) {
      this.useEdittingItem(item)
    },
    item: {
      handler (item) {
        this.getPrice(item)
      },
      deep: true
    }
  },
  mounted () {
    this.useEdittingItem(this.edittingItem)
  },
  methods: {
    useEdittingItem (item) {
      if (!this.editChange) {
        if (item) {
          this.edit = true
          this.item = item
        }
      } else {
        this.item = {
          orderID: item.orderID,
          type: 'Scaffold',
          name: null,
          width: null,
          itemPrice: 0,
          total: 0,
          quantity: 1,
          variations: {
            scaffolding: null
          },
          ordering: 1000,
          notes: null
        }
        if (item && item._id) {
          this.item._id = item._id
        }
        this.item.orderID = item.orderID
      }
    },

    addItem () {
      this.$v.item.$touch()
      if (this.$v.item.$pending || this.$v.item.$error) return
      this.edit = false
      this.$emit('create-item', this.item)
    },
    async getPrice () {
      const response = await ItemService.getPricing(this.item)
      if (response.data.price) {
        this.item.itemPrice = response.data.itemPrice
        this.item.total = response.data.total
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/products/Scaffold.vue